export const formatTypes = [
    {
        value: 1,
        label: 'Excel',
    },
];

export const options = [
    {
        value: 0,
        label: 'Theo lĩnh vực',
    },
    {
        value: 1,
        label: 'Theo dự án',
    },
    {
        value: 2,
        label: 'Theo mảng công việc',
    },
];